export const VERSION = "2.6.0";
